import React from "react";
import { Link, useLocation } from "react-router-dom";
import { audienceFromLocation, audienceSites } from "../audience/audienceSites";

export default function Footer() {
  const audience = audienceFromLocation(useLocation());
  const site = audienceSites[audience];
  const links = site
    ? [{ to: site.base, label: "Home" }, ...site.navigation.filter(({ to }) => to !== site.base), { to: `${site.base}/contact?source=footer`, label: site.cta }]
    : Object.values(audienceSites).map(({ base, fullLabel }) => ({ to: base, label: fullLabel }));
  return (
    <footer className="shrink-0 border-t border-gray-200 bg-gray-50 px-6 py-12 text-gray-600 dark:border-white/[0.08] dark:bg-[#08090d] dark:text-white/65">
      <div className="mx-auto grid max-w-[1184px] gap-8 md:grid-cols-[1fr_1fr_auto]">
        <div>
          <Link to={site?.base || "/"} aria-label="Cornucopia home" className="inline-flex min-h-11 items-center">
            <img src="/Logo.svg" alt="" width="152" height="42" className="w-[116px] dark:hidden" />
            <img src="/Logo-dark.svg" alt="" width="152" height="42" className="hidden w-[116px] dark:block" />
          </Link>
          <p className="mt-4 text-xs">© {new Date().getFullYear()} Cornucopia Biosciences</p>
        </div>
        <nav aria-label="Footer navigation" className="flex flex-col items-start">
          {links.map(({ to, label }) => <Link key={to} to={to} className="inline-flex min-h-11 items-center text-sm hover:text-primary">{label}</Link>)}
        </nav>
        <div className="flex flex-col items-start text-sm">
          {site && <Link to="/" className="inline-flex min-h-11 items-center hover:text-primary">Change audience</Link>}
          <a className="inline-flex min-h-11 items-center hover:text-primary" href="mailto:hello@cornucopiabio.com">Email us</a>
          <a className="inline-flex min-h-11 items-center hover:text-primary" href="https://linkedin.com/company/cornucopiabio">LinkedIn</a>
          {audience === "scientist" && <Link to="/careers?audience=scientist" className="inline-flex min-h-11 items-center hover:text-primary">Careers</Link>}
        </div>
      </div>
    </footer>
  );
}
